export default __webpack_public_path__ + "static/media/family.85a4acc5.png";